import React, { useEffect } from 'react';
import '../../assets/css/easy-chat-iframe.less';

interface IProps {
    url: string;
}

const Index = (props: IProps) => {
    const { url } = props;
    
    useEffect(() => {
        const _body: any = document.querySelector('body');
        _body.className = 'easychat-page';
    }, []);

    return (
        <iframe
            className='easy-chat-iframe'
            src={url}
        ></iframe>
    )
};

export default Index;